import React from 'react';
import { BLOCKS } from '@contentful/rich-text-types';
import { GatsbyImage } from 'gatsby-plugin-image';
import styled from 'styled-components';

import { CARD_TYPES } from '../../shared/constants';

import mq from '../../styles/breakpoints';

import DownloadCard from '../../components/molecules/download-card/DownloadCard';

const EmbeddedDownloadCard = ({ linkedDownload }) => (
  <StyledDownloadCard
    key={linkedDownload?.contentful_id}
    title={linkedDownload?.title}
    buttonText={linkedDownload?.primaryLink?.label}
    file={linkedDownload?.primaryLink?.asset?.file?.url}
  />
);

export const getEmbeddedOptions = (references) => {
  return {
    [BLOCKS.EMBEDDED_ASSET]: ({ data }) => {
      const embeddedAsset = references.find(
        (ref) => ref.contentful_id === data.target.sys.id
      );
      if (embeddedAsset.__typename === 'ContentfulAsset') {
        return <GatsbyImage alt="" image={embeddedAsset.gatsbyImageData} />;
      }
    },
    [BLOCKS.EMBEDDED_ENTRY]: (node) => {
      // Match id from current raw span with embedded 'references'
      const { data } = node;
      const embeddedEntry = references.find(
        (ref) => ref.contentful_id === data.target.sys.id
      );

      // You can add in other embedded entries by checking the typename
      if (embeddedEntry.type === CARD_TYPES.download) {
        return <EmbeddedDownloadCard linkedDownload={embeddedEntry} />;
      }
    },
  };
};

const StyledDownloadCard = styled(DownloadCard)`
  margin: 32px 0;

  ${mq.from.breakpoint.L`
    margin: 40px 0;
  `}
`;
